import { Reducer } from 'redux';
import { TransactionState, TransactionTypes } from './types';
import { AuthActionTypes } from '../auth';

export const initialState: TransactionState = {
  currencies: [],
  currenciesLoading: false,
  currencyError: undefined,
  transactionError: undefined,
  loading: false,
  transactions: null,
  isExporting: false,
  exportStream: undefined,
  isExportSuccess: false,
  isExportError: false,
  transactionExportError: undefined,
  downloadReceiptStream: undefined,
  downloadRecieptError: false,
  downloadRecieptSuccess: false,
  isRequestingDownload: false,
  downloadError: undefined,
  transactionsReasons: [],
  transactionLogs: null,
  transactionLogsLoading: false,
  transactionLogsError: null,
};

const reducer: Reducer<TransactionState> = (state = initialState, action) => {
  switch (action.type) {
    case TransactionTypes.GET_TRANSACTIONS_REQUEST:
    case TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        transactions: null,
        transactionError: undefined,
        transactionExportError: undefined,
      };
    case TransactionTypes.GET_TRANSACTIONS_SUCCESS:
    case TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        transactions: action.payload,
        loading: false,
        transactionError: undefined,
      };
    case TransactionTypes.GET_TRANSACTIONS_FAILURE:
    case TransactionTypes.VIEW_TRANSACTIONS_OVERVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        transactionError: action.payload,
      };
    case TransactionTypes.GET_CURRENCIES:
      return {
        ...state,
        currenciesLoading: true,
      };
    case TransactionTypes.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action.payload,
        currenciesLoading: false,
      };
    case TransactionTypes.GET_CURRENCIES_FAILURE:
      return {
        ...state,
        currenciesLoading: false,
        currencyError: action.payload,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_REQUEST:
    case TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_REQUEST:
      return {
        ...state,
        isExporting: true,
        transactionExportError: undefined,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_SUCCESS:
    case TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        isExporting: false,
        exportStream: action.payload,
        isExportError: false,
        isExportSuccess: true,
        transactionExportError: undefined,
      };
    case TransactionTypes.EXPORT_TRANSACTIONS_FAILURE:
    case TransactionTypes.EXPORT_VIEW_TRANSACTIONS_OVERVIEW_FAILURE:
      return {
        ...state,
        isExporting: false,
        exportStream: undefined,
        isExportError: true,
        isExportSuccess: false,
        transactionExportError: action.payload,
      };
    case TransactionTypes.DOWNLOAD_RECEIPT_REQUEST:
      return {
        ...state,
        isRequestingDownload: true,
      };

    case TransactionTypes.DOWNLOAD_RECEIPT_SUCCESS:
      return {
        ...state,
        isRequestingDownload: false,
        downloadReceiptStream: action.payload,
        downloadRecieptError: false,
        downloadRecieptSuccess: true,
        downloadError: undefined,
      };

    case TransactionTypes.DOWNLOAD_RECEIPT_FAILURE:
      return {
        ...state,
        isRequestingDownload: false,
        downloadReceiptStream: undefined,
        downloadRecieptError: true,
        downloadRecieptSuccess: false,
        downloadError: action.payload,
      };
    case TransactionTypes.GET_TRANSACTION_REASONS_SUCCESS:
      return {
        ...state,
        transactionsReasons: action.payload,
      };
    case TransactionTypes.GET_TRANSACTION_LOGS_REQUEST:
      return {
        ...state,
        transactionLogsLoading: true,
        transactionLogsError: null,
      };
    case TransactionTypes.GET_TRANSACTION_LOGS_SUCCESS:
      return {
        ...state,
        transactionLogs: action.payload,
        transactionLogsLoading: false,
      };
    case TransactionTypes.GET_TRANSACTION_LOGS_FAILURE:
      return {
        ...state,
        transactionLogsError: action.payload,
        transactionLogsLoading: false,
      };
    case AuthActionTypes.DESTROY_STATES:
      return initialState;
    default:
      return state;
  }
};

export { reducer as transactionReducer };
